/**
 * 书架渲染与统一搜索 UI 编排
 */
import { setSafeInnerHTML } from './htmlSecurityModule.js';

export function syncUnifiedSearchUi(state, elements) {
  const input = elements?.searchInput;
  const clear = elements?.searchClear;
  if (!input || !clear) return;

  input.placeholder = '';

  if (state?.currentView === 'booklist') {
    const inBooklist = !!state?.booklist?.currentBooklistId;
    const value = inBooklist
      ? String(state?.booklist?.bookSearch || '')
      : String(state?.booklist?.search || '');

    if (input.value !== value) input.value = value;
    clear.style.display = value.trim() ? 'flex' : 'none';
    return;
  }

  if (state?.currentView === 'shelf') {
    if (input.value !== (state?.searchQuery || '')) {
      input.value = state?.searchQuery || '';
    }
    clear.style.display = state?.searchQuery ? 'flex' : 'none';
    return;
  }

  input.value = '';
  clear.style.display = 'none';
}

export function renderBookshelfView(context = {}) {
  const {
    state,
    elements,
    updateWelcomeMessage,
    updateShelfStats,
    updateRecentTimeline,
    updateFormatFilters,
    renderCategoryFilters,
    filterBooks,
    sortBooks,
    buildMixedShelfItems,
    createCollectionCardHtml,
    createCollectionListItemHtml,
    createBookCard,
    createBookListItem,
    getFilteredCollectionsForShelf,
    buildCollectionShelfHeaderHtml,
    updateBookshelfDragState
  } = context;

  updateWelcomeMessage();
  updateShelfStats();
  updateRecentTimeline();
  updateFormatFilters();
  renderCategoryFilters();

  let filteredBooks = filterBooks(state.books);
  filteredBooks = sortBooks(filteredBooks);

  if (state.books.length === 0) {
    setSafeInnerHTML(elements.booksGrid, '', { profile: 'app' });
    elements.emptyShelf.style.display = 'none';
    elements.shelfStats.style.display = 'none';
    if (elements.formatTrigger) elements.formatTrigger.parentElement.style.display = 'none';
    elements.categoryFilters.style.display = 'none';
    return;
  }

  elements.emptyShelf.style.display = 'none';
  elements.shelfStats.style.display = '';
  if (elements.formatTrigger) elements.formatTrigger.parentElement.style.display = '';
  elements.categoryFilters.style.display = 'flex';

  if (state.filterCollection === 'all') {
    const mixed = buildMixedShelfItems({
      state,
      filteredBooks,
      createCollectionCardHtml,
      createCollectionListItemHtml,
      createBookCard,
      createBookListItem,
      getFilteredCollectionsForShelf
    });
    elements.booksGrid.className = mixed.className;
    setSafeInnerHTML(elements.booksGrid, mixed.html, { profile: 'app' });
    updateBookshelfDragState();
    return;
  }

  if (state.isGridView) {
    const headerHtml = buildCollectionShelfHeaderHtml(true);
    elements.booksGrid.className = 'books-grid';
    setSafeInnerHTML(elements.booksGrid, `${headerHtml}${filteredBooks.map(book => createBookCard(book)).join('')}`, { profile: 'app' });
  } else {
    const headerHtml = buildCollectionShelfHeaderHtml(false);
    elements.booksGrid.className = 'books-list';
    setSafeInnerHTML(elements.booksGrid, `${headerHtml}${filteredBooks.map(book => createBookListItem(book)).join('')}`, { profile: 'app' });
  }

  updateBookshelfDragState();
}
